import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import OutsideClickHandler from 'react-outside-click-handler';

import { Box } from '@material-ui/core';

import SituationLabel from './SituationLabel';

import Button from '../../Button';
import Modal from '../../Modal';
import PageLoader from '../../PageLoader';
import Icon from '../../Icons';

import { useGlobal } from '../../../contexts/Global/context';

import { getFormattedContractLoginData } from '../../../utils/getFormattedContractLoginData';

import * as Styles from '../../Inputs/styles';

import * as S from './styles';
import Input from '../../Inputs/Input';

export function ContractChange({ isHome }) {
    const {
        contractsGroupsList,
        dataActiveContract,
        setDataActiveContract,
        dataLogin,
        setDataLogin,
        setContractsList,
        useAllContracts,
        setUseAllContracts,
    } = useGlobal();

    const contractOptionStyle = { padding: '8px 24px' };

    const history = useHistory();

    const optionsRef = useRef(null);

    const [searchField, setSearchField] = useState({
        id: `searchOptionsContracts`,
        label: '',
        value: '',
        icon: { name: 'search', type: 'round', size: 14 },
    });

    const [isOpen, setIsOpen] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const { contrastTheme } = useGlobal();

    const mapContractGroupsList = ({ grupoContrato, idGrupoContrato, contratos }) => {
        const groupOption = {
            codigo: idGrupoContrato,
            nome: `${idGrupoContrato} - ${grupoContrato}`,
            isGroup: true,
        };

        const contractsOptions = contratos.map(({ numeroContrato, nomeContrato, ...rest }) => ({
            codigo: numeroContrato,
            nome: `${numeroContrato} - ${nomeContrato}`,
            contractsList: contratos,
            numeroContrato,
            nomeContrato,
            ...rest,
        }));

        return [groupOption, ...contractsOptions];
    };

    const [treatedData, setTreatedData] = useState(() => contractsGroupsList.map(mapContractGroupsList).flat());

    const [filtered, setFiltered] = useState(treatedData);

    async function handleChangeContract(dataContract) {
        if (dataContract.isGroup) return;

        setIsOpen(false);

        setIsDisabled(true);

        const params = {
            contract: dataContract,
            email: dataLogin.email,
        };

        const { formattedContract, profileData } = await getFormattedContractLoginData(params);

        if (formattedContract.isDental) {
            setShowModal(true);
            setModalMessage(
                'Temporariamente, os contratos Odonto não estão disponíveis para acesso neste portal. Você pode acessá-los a partir da área de Empresas do portal GNDI, clicando na opção "Odonto".'
            );

            setIsOpen(false);

            setIsDisabled(false);

            return;
        }

        if (formattedContract.vigenciaFutura) {
            setShowModal(true);
            setModalMessage(
                'Esse contrato possui vigência futura. Acesse novamente após a data de início da vigência.'
            );

            setIsOpen(false);

            setIsDisabled(false);

            return;
        }

        setDataLogin({ ...dataLogin, ...profileData });

        setDataActiveContract(formattedContract);

        setContractsList(dataContract.contractsList);

        setUseAllContracts(false);

        setIsDisabled(false);

        history.push('/');
    }

    function handleFilterOptions(event) {
        const { value } = event;

        setSearchField({
            ...searchField,
            value,
        });

        const filteredList = treatedData.filter(
            ({ nome }) => nome?.toLowerCase().includes(value?.toLowerCase()) || !value
        );
        setFiltered(filteredList);
    }

    function focusSearchInput() {
        optionsRef.current.querySelector('input').focus();
    }

    function getFirstChild() {
        const { lastChild: ul } = optionsRef.current;
        const { firstChild } = ul;

        return firstChild;
    }

    function isFirstChildOptions(actualId) {
        return actualId === getFirstChild().id;
    }

    function handleKeyPressOption({ event, dataOption }) {
        const $element = event.target;

        if ($element.tagName === 'LI' && ['Space', 'Enter'].includes(event.code)) {
            handleChangeContract(dataOption);

            return;
        }

        switch (event.code) {
            case 'ArrowUp':
                if (isFirstChildOptions(event.target.id)) {
                    focusSearchInput();
                    break;
                }

                if ($element.previousElementSibling) {
                    $element.previousElementSibling.focus();
                }

                break;

            case 'ArrowDown':
                if ($element.tagName === 'INPUT') {
                    getFirstChild().focus();
                    break;
                }

                if ($element.nextElementSibling) $element.nextElementSibling.focus();
                break;

            case 'Escape':
                setIsOpen(false);
                break;

            default:
                break;
        }
    }

    useEffect(() => {
        document.querySelector('#page-content').style.overflow = isOpen ? 'hidden' : 'auto';

        if (isOpen) {
            optionsRef.current.scrollTo(0, 0);
        }
    }, [isOpen]);

    useEffect(() => {
        if (treatedData.length <= 0) {
            const newTreatedData = contractsGroupsList.map(mapContractGroupsList).flat();
            setTreatedData(newTreatedData);
            setFiltered(newTreatedData);
        }
    }, [contractsGroupsList]);

    return (
        <>
            <Box display="block">
                <S.ContractContainer display="flex" justifyContent="flex-end" alignItems="center">
                    <S.InfoContract>
                        <h1 className="section-title-contract-change">
                            Contrato - {(!useAllContracts || !isHome) && dataActiveContract.numero}
                        </h1>
                        <span className="active-contract">
                            {useAllContracts && isHome ? 'Todos os contratos' : dataActiveContract.nome}
                        </span>
                    </S.InfoContract>

                    <OutsideClickHandler
                        onOutsideClick={() => {
                            if (isOpen) {
                                setIsOpen(false);
                            }
                        }}
                    >
                        <S.IconContainer onClick={() => setIsOpen(!isOpen)}>
                            <Icon name="ArrowDown" color={contrastTheme ? '#FFF333' : '#EC6E0C'} />
                        </S.IconContainer>

                        <Styles.ContainerOptions
                            ref={optionsRef}
                            isOnFocus={isOpen}
                            style={{ right: '0px', top: '60px', width: '450px', maxHeight: '60vh' }}
                        >
                            {treatedData.length > 10 && (
                                <Input
                                    onKeyDown={(event) => handleKeyPressOption({ event })}
                                    field={searchField}
                                    onChange={handleFilterOptions}
                                />
                            )}

                            <ul>
                                {filtered.length === 0 && !isHome && (
                                    <li className="no-data-found">
                                        <span>Nenhuma opção encontrada...</span>
                                    </li>
                                )}

                                {filtered.map(({ codigo, nome, isGroup, ...rest }, index) => {
                                    const contractStyle = !isGroup ? contractOptionStyle : {};

                                    return (
                                        <li
                                            key={index}
                                            id={`contrato_${codigo}`}
                                            className={isGroup && 'group-name'}
                                            tabIndex="0"
                                            onKeyDown={(event) =>
                                                handleKeyPressOption({
                                                    event,
                                                    dataOption: { codigo, nome, isGroup, ...rest },
                                                })
                                            }
                                            style={{ ...contractStyle }}
                                            onClick={() => handleChangeContract({ codigo, nome, isGroup, ...rest })}
                                        >
                                            <S.CustomListContract>{nome}</S.CustomListContract>
                                        </li>
                                    );
                                })}
                            </ul>
                        </Styles.ContainerOptions>
                    </OutsideClickHandler>
                </S.ContractContainer>

                <SituationLabel contrastTheme={contrastTheme} situation={dataActiveContract.situationLabel} />
            </Box>

            <Modal
                title="Atenção"
                subtitle={modalMessage}
                visible={showModal}
                onCancel={() => setShowModal(false)}
                footer={null}
            >
                <Button
                    type="primary"
                    onClick={() => {
                        setShowModal(false);
                    }}
                >
                    Entendi
                </Button>
            </Modal>

            <PageLoader loading={isDisabled} />
        </>
    );
}
